/* eslint-disable jira/filename-case */

import { token } from '@atlaskit/tokens';
import { toPoint, type Point } from './toPortInfo.tsx';

export const MINIMUM_ZOOM_LEVEL = 0.5;
export const MAXIMUM_ZOOM_LEVEL = 2;
export const DEFAULT_ZOOM_LEVEL = 1;

export const LINEAR_ZOOM_STEP = 0.1;

export const DEFAULT_PAN: Point = toPoint(600, 80);

export const STATUS_HEIGHT = 32;

export const TRANSITION_STROKE_WIDTH = 2;

export const START_NODE_RADIUS = 20;
export const PORT_RADIUS = 5;
export const GLOBAL_TRANSITION_PORT_OFFSET = 2;
export const ARROW_PORT_OFFSET: number = PORT_RADIUS / 2;
export const ARROW_WING_LENGTH = 5;

export const GLOBAL_TRANSITION_PORT = 3;

export const STATE_COLOURS: {
	focused: 'var(--ds-border-focused)';
	selected: 'var(--ds-border-selected)';
	warning: 'var(--ds-border-warning)';
	error: 'var(--ds-border-danger)';
} = {
	focused: token('color.border.focused'),
	selected: token('color.border.selected'),
	warning: token('color.border.warning'),
	error: token('color.border.danger'),
};

export const MAX_LABEL_LENGTH = 40;
export const ELLIPSIS = '\u2026';
